import * as React from 'react';
import classNames from 'classnames';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import MuiTable from '@mui/material/Table';

interface IProps {
  fixedLayout?: boolean;
  stretch?: boolean;
  stretchHeight?: boolean;
  autoWidth?: boolean;
  noBorderCollapse?: boolean;
  className?: string;
  size?: 'small' | 'medium';
  classes?: any;
}

const styles = (theme: Theme) => ({
  fixedLayoutClass: {
    tableLayout: 'fixed',
    width: '100%',
  },
  stretchLayoutClass: {
    minWidth: '100%',
    whiteSpace: 'nowrap',
  },
  stretchHeightLayoutClass: {
    minHeight: '100%',
  },
  autoClass: {
    width: 'auto',
    whiteSpace: 'nowrap',
  },
  noCollapse: {
    borderCollapse: 'separate',
    borderSpacing: theme.spacing(0),
  },
});

export const EDTable: React.FC<React.PropsWithChildren<IProps>> = props => {
  const {
    classes,
    fixedLayout,
    stretch,
    stretchHeight,
    autoWidth,
    noBorderCollapse,
    className,
    ...other
  } = props;
  const {
    fixedLayoutClass,
    stretchLayoutClass,
    stretchHeightLayoutClass,
    autoClass,
    noCollapse,
    ...otherClasses
  } = classes;

  return (
    <MuiTable
      {...other}
      classes={{ ...otherClasses }}
      className={classNames(className, {
        [stretchLayoutClass]: stretch,
        [stretchHeightLayoutClass]: stretchHeight,
        [fixedLayoutClass]: fixedLayout,
        [autoClass]: autoWidth,
        [noCollapse]: noBorderCollapse,
      })}
    />
  );
};

export default withStyles(EDTable, styles);
